/* eslint-disable max-len */
import { Box } from "@mui/material";
import React from "react";
import { StyledBookingFlowButton } from "./BookingScheduleContainer.style";
import { useAllServiceStatusStore, useBookingAppointmentTypeStore } from "../../../hooks";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import { BookingTypeToggleCard } from "../../../components";
import AvailableTimeSlots from "../../../components/AvailableTimeSlots/AvailableTimeSlots";
import UrgentVisitToggleCard from "../../containers/ReasonForVisitContainer/UrgentVisitToggleCard";
import { useModal } from "../../../context/ModalContext";

interface IBookingRescheduleContainer{
  handleStep: () => void;
  isCtaDisabled?: boolean;
}

const BookingRescheduleContainer = ({
  handleStep,
  isCtaDisabled=false,
}: IBookingRescheduleContainer) => {
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();
  const { isDropOffServiceAvailable }=useAllServiceStatusStore();
  const { openModal } = useModal();

  const handleContinue = () =>{
    handleStep();
  };

  const handleUrgentToggle = () => {
    openModal(MODALS.RESCHEDULE_URGENT_VISIT_MODAL);
  };


  return (
    <>
      <div className="w-full h-full flex flex-col justify-between ">
        <div
          className={"h-24 flex-grow w-full flex px-2 min-h-0 overflow-y-auto border border-taupe-50 rounded-xl scrollbar-thin"}>
          <AvailableTimeSlots
            title="Available times"
            isCarousal={false}
            isDropoff={(bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING) ? true : false}
            isRescheduleModal={true}
          />
        </div>
        <Box className="!sticky !bottom-0 !w-full ">
          {isDropOffServiceAvailable && <div className="my-1.5">
            <BookingTypeToggleCard />
          </div>}
          <div className="my-1.5">
            <UrgentVisitToggleCard handleToggle={handleUrgentToggle} />
          </div>
          <StyledBookingFlowButton
            disabled={isCtaDisabled}
            fullWidth
            color="primary"
            size="small"
            onClick={handleContinue}
          >
            Continue
          </StyledBookingFlowButton>
        </Box>
      </div>
    </>
  );
};

export default BookingRescheduleContainer;
